import { Card, Box, CardContent, Typography, Grid } from "@mui/material";

export const SectionCard = ({ caption, value }) => (
  <Grid item xs={12} md={4}>
    <Card
      variant="outlined"
      sx={{
        transition: "border-color 0.2s",
        "&:hover": {
          borderColor: "primary.main",
        },
      }}
    >
      <CardContent>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontWeight: 500 }}
        >
          {caption}
        </Typography>

        <Box sx={{ mt: 5 }}>
          <Typography variant="h3" fontWeight="bold">
            {value}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  </Grid>
);
